import React from 'react';
import {Icon, Menu} from "antd";
import {matchPath, withRouter} from "react-router";
import {BreadcrumbContext} from "./BreadcrumbContext";
import {Link} from "react-router-dom";
import SignOutButton from "./SignOutButton";
import NotificationButton from "./NotificationButton";
import logo from '../cProject-banner-new.png';
import NotificationPoller from "./NotificationPoller";

const items = [
  {
    key: 'bids-all',
    text: 'Bids',
    icon: <Icon type='dollar'/>,
    renderOn: { path: '/' },
    dest: params => '/bids/',
    selected: { path: '/bids/' },
  },
  {
    key: 'projects-all',
    text: 'Projects',
    icon: <Icon type='project'/>,
    renderOn: { path: '/' },
    dest: params => '/projects/',
    selected: { path: '/projects/' },
  },
  {
    key: 'reports',
    text: 'Reports',
    icon: <Icon type='area-chart'/>,
    renderOn: { path: '/' },
    dest: params => '/reports/bid-status',
    selected: { path: '/reports/' },
    children: [
      {
        key: 'bid-status',
        selected: "/reports/bid-status",
        dest: () => "/reports/bid-status",
        renderOn: {path: '/'},
        text: "Bid Status"
      },
      {
        key: 'upcoming-bids',
        selected: "/reports/upcoming-bids",
        dest: () => "/reports/upcoming-bids",
        renderOn: {path: '/'},
        text: "Upcoming Bids"
      },
      {
        key: 'upcoming-bid-details',
        selected: "/reports/upcoming-bid-details",
        dest: () => "/reports/upcoming-bid-details",
        renderOn: {path: '/'},
        text: "Upcoming Bid Details"
      },
      {
        key: 'project-status',
        selected: "/reports/project-status",
        dest: () => "/reports/project-status",
        renderOn: {path: '/'},
        text: "Project Status"
      },
      {
        key: 'task-status',
        selected: "/reports/task-status",
        dest: () => "/reports/task-status",
        renderOn: {path: '/'},
        text: "Task Status"
      },
      {
        key: 'task-details',
        selected: "/reports/task-details",
        dest: () => "/reports/task-details",
        renderOn: {path: '/'},
        text: "Task Details"
      },
      {
        key: 'rfi-status',
        selected: "/reports/rfi-status",
        dest: () => "/reports/rfi-status",
        renderOn: {path: '/'},
        text: "RFI Status"
      },
      {
        key: 'rfi-details',
        selected: "/reports/rfi-details",
        dest: () => "/reports/rfi-details",
        renderOn: {path: '/'},
        text: "RFI Details"
      },
      {
        key: 'submittal-status',
        selected: "/reports/submittal-status",
        dest: () => "/reports/submittal-status",
        renderOn: {path: '/'},
        text: "Submittal Status"
      },
      {
        key: 'submittal-details',
        selected: "/reports/submittal-details",
        dest: () => "/reports/submittal-details",
        renderOn: {path: '/'},
        text: "Submittal Details"
      },
      {
        key: 'punchlist-status',
        selected: "/reports/punchlist-status",
        dest: () => "/reports/punchlist-status",
        renderOn: {path: '/'},
        text: "Punch List Status"
      },
      {
        key: 'daily-log-details',
        selected: "/reports/daily-log-details",
        dest: () => "/reports/daily-log-details",
        renderOn: {path: '/'},
        text: "Daily Logs"
      },
      {
        key: 'meeting-minutes-details',
        selected: "/reports/meeting-minutes-details",
        dest: () => "/reports/meeting-minutes-details",
        renderOn: {path: '/'},
        text: "Meeting Minutes"
      },
    ]
  },
  {
    key: 'settings',
    text: 'Settings',
    icon: <Icon type='setting'/>,
    renderOn: { path: '/' },
    dest: params => '/settings/',
    selected: { path: '/settings/' },
    children: [
      {
        key: 'profile',
        text: 'User Profile',
        renderOn: '/',
        dest: params => "/settings/profile",
        selected: { path: "/settings/profile" },
      },
      {
        key: 'company-profile',
        text: 'Company Profile',
        renderOn: '/',
        dest: params => "/settings/company-profile",
        selected: { path: "/settings/company-profile" },
      },
      {
        key: 'address-book',
        text: 'Address Book',
        renderOn: '/',
        dest: params => "/settings/address-book",
        selected: { path: "/settings/address-book" },
      },
      {
        key: 'contact-lists',
        text: 'Contact Lists',
        renderOn: '/',
        dest: params => "/settings/contact-lists",
        selected: { path: "/settings/contact-lists" },
      },
      {
        key: 'email-notification',
        text: 'Email Notification',
        renderOn: '/',
        dest: params => "/settings/email-notification",
        selected: { path: "/settings/email-notification" },
      },
      {
        key: 'privacy',
        text: 'Privacy',
        renderOn: '/',
        dest: params => "/settings/privacy",
        selected: { path: "/settings/privacy" },
      },
    ]
  },

];

const renderChildren = (history, location, children, parent) => {
  return children.map(item => {
    let match;
    if (item.renderOn.not) {
      match = !matchPath(location.pathname, item.renderOn.not);
    } else {
      match = matchPath(location.pathname, item.renderOn);
    }
    if (!match) {
      return null;
    } else if (item.children) {
      return <Menu.SubMenu
        name={item.key}
        key={item.key}
        disabled={item.disabled}
        title={<span>{item.icon}<span>{item.text}</span></span>}
      >
        {renderChildren(history, location, item.children, item)}
      </Menu.SubMenu>
    } else {
      return <Menu.Item
        name={item.key}
        key={item.key}
        disabled={item.disabled}
        onClick={() => item.dest && history.push(item.dest(match && match.params))}
      >
        {item.icon && item.icon}
        <span>{item.text}</span>
      </Menu.Item>
    }
  });
};

const flattenChildren = (children) => {
  return children.reduce((acc, val) => Array.isArray(val.children) ? acc.concat(flattenChildren(val.children)) : acc.concat(val), []);
};

const getMenuItems = (history, location, orientation, theme) => {
  orientation = orientation || 'inline';
  theme = theme || 'light';
  let menuItems = renderChildren(history, location, items, null);
  let selectedKeys = flattenChildren(items)
    .map(item => ({
      item,
      match: matchPath(location.pathname, item.renderOn),
      selected: matchPath(location.pathname, item.selected)
    }))
    .filter(({ selected }) => !!selected)
    .map(({ item }) => item.key);
  return (
    <Menu
      mode={orientation}
      theme={theme}
      defaultSelectedKeys={['dashboard']}
      selectedKeys={selectedKeys}
      className='content-nav'
    >
      {menuItems}
    </Menu>
  );
};

const _GlobalHeader = ({ history, location }) => <React.Fragment>
  <div id='navbar'>
    <div id='logo' style={{ backgroundImage: `url(${logo})` }}/>
    <div id='control'>
      <div className='content-nav-wrapper'>
        {getMenuItems(history, location, 'horizontal', 'light')}
      </div>
      <div className='user-nav-wrapper'>
        <NotificationButton/>
        <NotificationPoller/>
        <SignOutButton theme='light'/>
      </div>
    </div>
  </div>
  <div className='user-nav-breadcrumbs print-hidden'>
    <BreadcrumbContext.Consumer>
      {({ crumbs }) => crumbs
        .map(crumb => {
          if (React.isValidElement(crumb)) {
            return crumb;
          } else {
            return (
              <div
                key={crumb.path}
              >
                <Link to={crumb.path} className='breadcrumb'>{crumb.title}</Link>
              </div>
            );
          }
        })
        .reduce((a, b) => {
          if (!a.length) return [b];
          return [...a, <div className='breadcrumb separator'><Icon type='double-right'
                                                                    className='ant-tabs-tab-next-icon-target'/>
          </div>, b];
        }, [])
      }
    </BreadcrumbContext.Consumer>
  </div>
</React.Fragment>;

const _RegistrationHeader = ({ authState, history, location }) => <React.Fragment>
  <div id='navbar'>
    <div id='logo' style={{ backgroundImage: `url(${logo})` }}/>
    <div id='control'>
      <div className='content-nav-wrapper'/>
      <div className='user-nav-wrapper'>
        {authState === 'beginUserRegistration' ?
          <Link to='/'><SignOutButton theme='light'/></Link> :
          <SignOutButton theme='light'/>
        }
      </div>
    </div>
  </div>
</React.Fragment>;

const _PublicHeader = ({ authState, history, location }) => <React.Fragment>
  <div id='navbar'>
    <div id='logo' style={{ backgroundImage: `url(${logo})` }}/>
    <div id='control'>
      <div className='content-nav-wrapper'/>
      <div className='user-nav-wrapper'/>
    </div>
  </div>
</React.Fragment>;

export const GlobalHeader = withRouter(_GlobalHeader);

export const RegistrationHeader = withRouter(_RegistrationHeader);

export const PublicHeader = withRouter(_PublicHeader);



// WEBPACK FOOTER //
// ./src/components/Boilerplate/Menus.js